import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import TerminalConfig from "../tabcomponents/configs/terminal/terminalconfig";
import TransactionControlConfig from "../tabcomponents/configs/transactioncontrol/transactioncontrolconfig";
import HostConfig from "../tabcomponents/configs/host/hostconfig";
import HeaderConfig from "../tabcomponents/configs/header/headerconfig";
import InstallmentConfig from "../tabcomponents/configs/installment/instalmentconfig";
import CurrencyConfig from "../tabcomponents/configs/currency/currencyconfig";
import TransactionPasswordConfig from "../tabcomponents/configs/transactionpassword/transactionpasswordconfig";
import EmvParamsConfig from "../tabcomponents/configs/evmparams/emvparamsconfig";
import CardConfig from "../tabcomponents/configs/card/cardconfig";
import CAPKConfig from "../tabcomponents/configs/capk/capkconfig";

const TabConfig = ({ selectedRowData }) => {
    const [selectedTab, setSelectedTab] = useState(0);

    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const tabComponents = [
        { label: "Terminal Config", component: <TerminalConfig selectedRowData={selectedRowData}/> },
        { label: "Transaction Control Config", component: <TransactionControlConfig selectedRowData={selectedRowData}/> },
        { label: "Host Config", component: <HostConfig selectedRowData={selectedRowData}/> },
        { label: "CardConfig", component: <CardConfig selectedRowData={selectedRowData}/> },
        { label: "Header Config", component: <HeaderConfig selectedRowData={selectedRowData}/> },
        { label: "Installment Config", component: <InstallmentConfig selectedRowData={selectedRowData}/> },
        { label: "Currency Config", component: <CurrencyConfig selectedRowData={selectedRowData}/> },
        { label: "Transaction Password Config", component: <TransactionPasswordConfig selectedRowData={selectedRowData}/> },
        { label: "EMV Params Config", component: <EmvParamsConfig selectedRowData={selectedRowData}/> },
        { label: "CAPK Config", component: <CAPKConfig selectedRowData={selectedRowData}/> },

    ];

    return (
      <Box sx={{ width: "100%", bgcolor: "white" }}>
        {/* Info Box */}
        <Box
          sx={{
            bgcolor: "#f9f9f9",
            p: 2,
            borderRadius: 2,
            mb: 2,
          }}
        >
          {/*<Typography variant="h6">*/}
          {/*    Parameters Template for Config*/}
          {/*</Typography>*/}
          <Typography variant="body2" color="text.secondary">
            <b>Parameters for </b> : {selectedRowData?.controlName}
          </Typography>
        </Box>

        {/* Tabs */}
        <Tabs
          value={selectedTab}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          TabIndicatorProps={{
            style: {
              backgroundColor: "#1a73e8",
              height: "3px",
              borderRadius: "3px",
            },
          }}
          sx={{
            backgroundColor: (theme) => (theme.palette.mode === "dark" ? "#2c2c2c" : "#fdfdfd80"),
            borderRadius: 2,
            "& .MuiTabs-flexContainer": {
              alignItems: "center",
            },
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 500,
              fontSize: "12px",
              color: "#5f6368",
              px: "6px !important", // internal spacing instead of external gap
              minHeight: "40px !important",
              minWidth: "100px !important",
              whiteSpace: "fit-content !important",
            },
            "& .MuiTab-root:first-of-type": {
              paddingLeft: "6px !important",
            },
            "& .Mui-selected": {
              color: "#1a73e8 !important", // Blue color for selected tab
            },
            "& .MuiTabs-scrollButtons": {
              color: "#1a73e8",
            },
          }}
        >
          {tabComponents.map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
          ))}
        </Tabs>

        <Box sx={{ mt: 2 }}>{tabComponents[selectedTab].component}</Box>
      </Box>
    );
};

TabConfig.propTypes = {
    selectedRowData: PropTypes.shape({
        controlName: PropTypes.string,
        controlType: PropTypes.string,
        slNo: PropTypes.number
    }),
};

export default TabConfig;
